
namespace Matrix.Workflow {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class ClientFunctionInvocationDialog extends SiteEntityDialog<ClientFunctionInvocationRow, any> {
        protected getFormKey() { return ClientFunctionInvocationForm.formKey; }
        protected getIdProperty() { return ClientFunctionInvocationRow.idProperty; }
        protected getLocalTextPrefix() { return ClientFunctionInvocationRow.localTextPrefix; }
        protected getNameProperty() { return ClientFunctionInvocationRow.nameProperty; }
        protected getService() { return ClientFunctionInvocationService.baseUrl; }

        protected form = new ClientFunctionInvocationForm(this.idPrefix);

        constructor() {
            super();

            $(window).on('resize.' + this.uniqueName, () => this.arrange());
        }

        destroy() {
            $(window).off('.' + this.uniqueName);
            super.destroy();
        }


        protected arrange() {
            super.arrange();
            var availHeight = $(window).height() - 290;
        }

        protected updateInterface() {
            super.updateInterface();

            this.cloneButton.hide();
            this.toolbar.findButton('edit-button').hide();
            if (!this.isViewMode) {
                makeReadOnly(this.byId('Form'));
                this.form.Parameters.element.css('height', '150px');
            }

            this.deleteButton.hide();

            if (this.entity) {
                this.toolbar.findButton('reject-button').toggle(this.entity.StatusCode === "PENDING");
                this.toolbar.findButton('re-run-button').toggle(!!this.entity.FunctionRerunnable);

                if (this.entity.StatusCode !== "PENDING") {
                    this.toolbar.element.hide();
                }
            }
        }

        protected getToolbarButtons() {
            var buttons = super.getToolbarButtons();
            buttons.push({
                title: "Re-run",
                cssClass: 're-run-button',
                icon: 'fa-repeat',
                onClick: () => {
                    Q.confirm('Re-run this function?', () => {
                        ClientFunctionTriggerView.Invoke({
                            InvocationId: this.entityId
                        },
                            () => {
                                Q.notifySuccess("The function was re-triggered.");
                                Serenity.SubDialogHelper.triggerDataChange(this);
                                this.dialogClose();
                            });
                    });
                }
            });
            return buttons;
        }

        protected afterLoadEntity() {
            super.afterLoadEntity();
            this.form.DurationMs.value = DurationFormatter.formatValue(this.entity.DurationMs);
            Workflow.replaceWithJsonViewer(this.form.Parameters.element, this.entity.Parameters);
            this.setWorkflowInsId();

        }

        protected setWorkflowInsId() {

            var link = $(".workflow-invocation-link", this.element);

            if (!link.length) {
                link = $('<a class="workflow-invocation-link"></a>')
                    .insertAfter(this.form.WorkflowInstanceId.element);
            }

            $('.workflow-invocation-link').attr('href', Q.resolveUrl("~/Workflow/WorkflowInstance#edit/") + this.form.WorkflowInstanceId.value)
                .toggle(!!this.form.WorkflowInstanceId.value)
                .text(this.form.WorkflowInstanceId.value?.toString() ?? '');

            $("[name='WorkflowInstanceId']").addClass("s-clientfunctioninvocation-invisible");
        }
    }
}